import { isUserAccountant } from 'packages/common/services/user';

const STEP_TITLE = {
  'step-2': 'trabalho',
  'step-3': 'contrato',
  'step-4': 'turno',
};

export const workerFormMixin = {
  data() {
    return {
    };
  },
  computed: {
    titleMixin() {
      const { step } = this.$route.query;
      const title = step ? `Informações de ${STEP_TITLE[`step-${step}`]}` : 'Informações básicas';
      return this.workerBasicInfo?.basicInfo
        ? `${title} de ${this.workerBasicInfo.basicInfo.name}`
        : title;
    },
    shouldShowAddButtonMixin() {
      return isUserAccountant();
    },
    selectColSizeMixin() {
      return this.shouldShowAddButtonMixin ? 8 : 12;
    },
  },
};
